import React from 'react';
import isMobile from '../mobile'
export const appendScript = (scriptToAppend) => {
    const script = document.createElement("script");
    script.src = scriptToAppend;
    script.async = true;
    document.body.appendChild(script);
}

export const trigger = () => {
  window.ASUHeader.toggleASU();
}

export const name = () => {
  if (window.document.cookie.split("SSONAME=").length === 2) {
    return window.document.cookie.split("SSONAME=").split(";")[0];
  } else {
    return "SIGN IN"
  }
  
}
var asuinfomenu = false;

export const asuinfo = () => {
  asuinfomenu = !asuinfomenu; 
}
export const infoclass = (val) => {
  if (!val) {
    return "clb"
  } else {
    return "clb closed"
  }
}

  
function Header(){
    appendScript("https://www.asu.edu/asuthemes/4.9/js/asu_header.js");
    appendScript('https://view.asu.edu/assets/analytics.js');
    return (
        <header id="asu_header" role="banner"  className={isMobile()}>
      <div className="container">
        <div id="block-asu-brand-asu-brand-header" className="block block-asu-brand">
          <div className="content">
            <div id="main-search" className="main-search closed">
              <form target="_top" action="https://search.asu.edu/search" method="get" name="gs" role="search">
                <label htmlFor="asu_search_box">Search</label>
                <input name="site" type="hidden" value="default_collection"/>
                <input name="sort" type="hidden" value="date:D:L:d1"/>
                <input name="output" type="hidden" value="xml_no_dtd"/>
                <input name="proxystylesheet" type="hidden" value="asu_frontend"/>
                <input name="ie" type="hidden" value="UTF-8"/>
                <input name="oe" type="hidden" value="UTF-8"/>
                <input name="client" type="hidden" value="asu_frontend"/>
                <input name="q" className="asu_search_box" id="asu_search_box" placeholder="Search" autoComplete="off" type="text"/>
                <input className="asu_search_button" type="submit" value="Search"/>
              </form>
            </div>
            <div id="asu-report-accessiblity" className="accessibility-hide">
              <a href="http://www.asu.edu/accessibility/feedback?a11yref=https%3A%2F%2Fwww.asu.edu%2F" className="sr-only">Report an accessibility problem</a>
            </div>
            <div id="asu_hdr" className="asu_hdr_white chrome">
              <div id="asu_mobile_hdr">
                <div className="asu_mobile_hdr_wrapper">
                  <div id="asu_logo">
                    <a id="asu-hdr-full-logo" href="https://www.asu.edu/" target="_top">
                      <img alt="Arizona State University" loading="lazy" src="https://www.asu.edu/asuthemes/4.9/assets/arizona-state-university-logo.png"/>
                    </a>
                    <a id="asu-hdr-mobile-logo" href="https://www.asu.edu/" target="_top">
                      <img alt="Arizona State University" src="https://www.asu.edu/asuthemes/4.9/assets/asu-logo.png"/>
                    </a>
                  </div>
                  <div className="asuhide f-navicon" id="asu_mobile_button"     onClick={trigger} role="button">
                    <a href="#">Menu</a>
                  </div>
                </div>
              </div>
              <div className="closed" id="asu_mobile_menu">
                <div className="asu_mobile_menu_wrapper">
                  <div id="asu_nav_wrapper">
                    <div id="search_new"></div>
                    <span className="hidden"> Sign In / Sign Out </span>
                    <ul id="asu_login_module">
                      <li className="end" id="asu_hdr_ssi">
                        {/* <a href="https://weblogin.asu.edu/cgi-bin/login?callapp=https%3A%2F%2Fview.asu.edu"     onFocus="this.href=ASUHeader.alterLoginHref(this.href);" onMouseOver="this.href=ASUHeader.alterLoginHref(this.href);" target="_top">{name()}</a> */}
                      </li>
                    </ul>
                    <div id="asu_nav_menu" role="navigation" aria-labelledby="asuNavLabel">
                      <span className="sr-only" id="asuNavLabel">
              Navigation for Entire University
            </span>
                      <div id="asu_universal_nav_new">
                        <ul>
                          <li className="tlb site_title">
                            <span></span>
                          </li>
                            {/* <li className="tlb">
                              <div className="text">
                                <a href="https://weblogin.asu.edu/cgi-bin/login"     onClick="this.href=ASUHeader.alterLoginHref(this.href);" onFocus="this.href=ASUHeader.alterLoginHref(this.href);" onMouseOver="this.href=ASUHeader.alterLoginHref(this.href);" target="_top">Sign In</a>
                              </div>
                              <div id="f-user" className="icn f-user"></div>
                            </li> */}
                          <li className="tlb" onClick={asuinfo}>
                            <div className="text">
                              <a href="#">ASU Info</a>
                            </div>
                            <div className="icn f-sort-down" ></div>
                          </li>
                          <li className={infoclass(asuinfomenu)}>
                            <ul>
                              <li className="cb">
                                <a href="//www.asu.edu/" target="_top">ASU Home</a>
                                <div className="icn2 f-sort-down"></div>
                              </li>
                              <li className="clb closed parent">
                                <ul>
                                  <li className="ccb">
                                    <a className="first" href="//www.asu.eduhttps://asu.edu/?feature=newsevents" target="_top" title="News and Events">News/Events</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//www.asu.eduhttps://asu.edu/?feature=academics" target="_top" title="Academics">Academics</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//www.asu.eduhttps://asu.edu/?feature=research" target="_top" title="Research">Research</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//www.asu.eduhttps://asu.edu/?feature=athletics" target="_top" title="Athletics">Athletics</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//www.asu.eduhttps://asu.edu/?feature=alumni" target="_top" title="Alumni">Alumni</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//www.asu.eduhttps://asu.edu/?feature=giving" target="_top" title="Giving">Giving</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//www.asu.eduhttps://asu.edu/?feature=president" target="_top" title="President">President</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//www.asu.edu/about" target="_top" title="About ASU">About ASU</a>
                                  </li>
                                </ul>
                              </li>
                              <li className="cb">
                                <a href="//my.asu.edu/" target="_top">My ASU</a>
                              </li>
                              <li className="cb">
                                <a href="//www.asu.edu/colleges/" target="_top">Colleges and Schools</a>
                                <div className="icn2 f-sort-down"></div>
                              </li>
                              <li className="clb closed parent">
                                <ul>
                                  <li className="ccb">
                                    <a className="first" href="//artsandsciences.asu.edu/" target="_top" title="Arts and Sciences website">Arts and Sciences</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//wpcarey.asu.edu/" target="_top" title="W. P. Carey School of Business Web and Morrison School of Agribusiness website">Business</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//herbergerinstitute.asu.edu" target="_top" title="Herberger Institute for Design and the Arts website">Design and the Arts</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//education.asu.edu/" target="_top" title="Mary Lou Fulton Teachers College website">Education</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//engineering.asu.edu/" target="_top" title="Engineering website">Engineering</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//sfis.asu.edu/" target="_top" title="Future of Innovation in Society website">Future of
                        Innovation in Society</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//graduate.asu.edu" target="_top" title="Graduate College website">Graduate</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//chs.asu.edu/" target="_top" title="Health Solutions website">Health Solutions</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//honors.asu.edu/" target="_top" title="Barrett, The Honors College website">Honors</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//cronkite.asu.edu" target="_top" title="Walter Cronkite School of Journalism and Mass Communication website">Journalism</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//www.law.asu.edu/" target="_top" title="Sandra Day O' Connor College of Law website">Law</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//nursingandhealth.asu.edu/" target="_top" title="College of Nursing and Health Innovation website">Nursing and Health Innovation</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//copp.asu.edu" target="_top" title="College of Public Programs website">Public Service and
                        Community Solutions</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//schoolofsustainability.asu.edu" target="_top" title="School of Sustainability website">Sustainability</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//uc.asu.edu/" target="_top" title="University College website">University College</a>
                                  </li>
                                  <li className="ccb">
                                    <a target="_top" href="https://thunderbird.asu.edu/" title="Thunderbird School of Global Management website">Thunderbird School of Global Management</a>
                                  </li>
                                </ul>
                              </li>
                              <li className="cb">
                                <a href="//www.asu.edu/map/" target="_top">Map and Locations</a>
                                <div className="icn2 f-sort-down"></div>
                              </li>
                              <li className="clb closed parent">
                                <ul>
                                  <li className="ccb">
                                    <a className="border first" href="//www.asu.edu/map/" target="_top">Map</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//campus.asu.edu/tempe/" target="_top" title="Tempe campus">Tempe</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//campus.asu.edu/west/" target="_top" title="West campus">West</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//campus.asu.edu/polytechnic/" target="_top" title="Polytechnic campus">Polytechnic</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//campus.asu.edu/downtown/" target="_top" title="Downtown Phoenix campus">Downtown
                        Phoenix</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//asuonline.asu.edu/" target="_top" title="Online and Extended campus">Online and
                        Extended</a>
                                  </li>
                                  <li className="ccb">
                                    <a className="border" href="//havasu.asu.edu/" target="_top">Lake Havasu</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="https://corporate.asu.edu/" target="_top">Corporate Engagement and Strategic Partnerships</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//asuresearchpark.com/" target="_top">Research Park</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//washingtoncenter.asu.edu/" target="_top">Washington D.C.</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="//wpcarey.asu.edu/mba/china-program/english/" target="_top">China</a>
                                  </li>
                                </ul>
                              </li>
                              <li className="cb">
                                <a href="//isearch.asu.edu/" target="_top" title="Directory, Index and other info">Directory</a>
                              </li>
                            </ul>
                          </li>
                          <li className="tlb">
                            <div className="text">
                              <a href="https://asu.edu/">Home</a>
                            </div>
                            <div className="icn f-share-square-o"></div>
                          </li>
                          <li className="tlb">
                            <div className="text">
                              <a href="https://asu.edu/?feature=newsevents">News/Events</a>
                            </div>
                            <div className="icn f-share-square-o"></div>
                          </li>
                          <li className="tlb">
                            <div className="text">
                              <a href="https://asu.edu/?feature=academics">Academics</a>
                            </div>
                            <div className="icn f-share-square-o"></div>
                          </li>
                          <li className="tlb">
                            <div className="text">
                              <a href="https://admission.asu.edu/">Admission</a>
                            </div>
                            <div className="icn f-share-square-o"></div>
                          </li>
                          <li className="tlb">
                            <div className="text">
                              <a href="https://asu.edu/?feature=research">Research</a>
                            </div>
                            <div className="icn f-share-square-o"></div>
                          </li>
                          <li className="tlb">
                            <div className="text">
                              <a href="https://asu.edu/?feature=athletics">Athletics</a>
                            </div>
                            <div className="icn f-share-square-o"></div>
                          </li>
                          <li className="tlb">
                            <div className="text">
                              <a href="https://asu.edu/?feature=alumni">Alumni</a>
                            </div>
                            <div className="icn f-share-square-o"></div>
                          </li>
                          <li className="tlb">
                            <div className="text">
                              <a href="https://asu.edu/?feature=giving">Giving</a>
                            </div>
                            <div className="icn f-share-square-o"></div>
                          </li>
                          <li className="tlb">
                            <div className="text">
                              <a href="https://asu.edu/?feature=president">President</a>
                            </div>
                            <div className="icn f-share-square-o"></div>
                          </li>
                          <li className="tlb">
                            <div className="text">
                              <a href="/about">About ASU</a>
                            </div>
                            <div className="icn f-sort-down"></div>
                          </li>
                          <li className="clb closed">
                            <ul>
                              <li className="cb">
                                <a href="#">Honors, rankings and facts</a>
                                <div className="icn2 f-sort-down"></div>
                              </li>
                              <li className="clb closed">
                                <ul>
                                  <li className="ccb">
                                    <a href="/rankings">Rankings</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/faculty-excellence">Faculty excellence</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/athletics-honors-and-awards">Athletics honors and awards</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/notable-alumni">Notable alumni</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/year-review-annual-report">Years in Review (annual report)</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/facts-and-figures">Facts and figures</a>
                                  </li>
                                </ul>
                              </li>
                              <li className="cb">
                                <a href="#">Overview</a>
                                <div className="icn2 f-sort-down"></div>
                              </li>
                              <li className="clb closed">
                                <ul>
                                  <li className="ccb">
                                    <a href="/about/charter-mission-and-values">Charter</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/leadership">Leadership</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/colleges-and-schools">Colleges and schools</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/centers-and-institutes">Centers and institutes</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/university-history-and-milestones">University history and milestones</a>
                                  </li>
                                </ul>
                              </li>
                              <li className="cb">
                                <a href="#">The ASU difference</a>
                                <div className="icn2 f-sort-down"></div>
                              </li>
                              <li className="clb closed">
                                <ul>
                                  <li className="ccb">
                                    <a href="/about/research">Research and innovation</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/unique-student-experience">Unique student experience</a>
                                  </li>
                                  <li className="ccb">
                                    <a href="/about/athletics">Elite athletics program</a>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                      <div id="asu_universal_nav">
                        <ul>
                          <li className="parent">
                            <a href="//www.asu.edu/" target="_top">ASU Home</a>
                            <ul>
                              <li>
                                <a className="first" href="//www.asu.eduhttps://asu.edu/?feature=newsevents" target="_top" title="News and Events">News/Events</a>
                              </li>
                              <li>
                                <a href="//www.asu.eduhttps://asu.edu/?feature=academics" target="_top" title="Academics">Academics</a>
                              </li>
                              <li>
                                <a href="//www.asu.eduhttps://asu.edu/?feature=research" target="_top" title="Research">Research</a>
                              </li>
                              <li>
                                <a href="//www.asu.eduhttps://asu.edu/?feature=athletics" target="_top" title="Athletics">Athletics</a>
                              </li>
                              <li>
                                <a href="//www.asu.eduhttps://asu.edu/?feature=alumni" target="_top" title="Alumni">Alumni</a>
                              </li>
                              <li>
                                <a href="//www.asu.eduhttps://asu.edu/?feature=giving" target="_top" title="Giving">Giving</a>
                              </li>
                              <li>
                                <a href="//www.asu.eduhttps://asu.edu/?feature=president" target="_top" title="President">President</a>
                              </li>
                              <li>
                                <a href="//www.asu.edu/about" target="_top" title="About ASU">About ASU</a>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <a href="//my.asu.edu/" target="_top">My ASU</a>
                          </li>
                          <li className="parent">
                            <a href="//www.asu.edu/colleges/" target="_top">Colleges and Schools</a>
                            <ul>
                              <li>
                                <a className="first" href="//artsandsciences.asu.edu/" target="_top" title="Arts and Sciences website">Arts and Sciences</a>
                              </li>
                              <li>
                                <a href="//wpcarey.asu.edu/" target="_top" title="W. P. Carey School of Business Web and Morrison School of Agribusiness website">Business</a>
                              </li>
                              <li>
                                <a href="//herbergerinstitute.asu.edu" target="_top" title="Herberger Institute for Design and the Arts website">Design and the Arts</a>
                              </li>
                              <li>
                                <a href="//education.asu.edu/" target="_top" title="Mary Lou Fulton Teachers College website">Education</a>
                              </li>
                              <li>
                                <a href="//engineering.asu.edu/" target="_top" title="Engineering website">Engineering</a>
                              </li>
                              <li>
                                <a href="//sfis.asu.edu/" target="_top" title="Future of Innovation in Society website">Future of
                        Innovation in Society</a>
                              </li>
                              <li>
                                <a href="//graduate.asu.edu" target="_top" title="Graduate College website">Graduate</a>
                              </li>
                              <li>
                                <a href="//chs.asu.edu/" target="_top" title="Health Solutions website">Health Solutions</a>
                              </li>
                              <li>
                                <a href="//honors.asu.edu/" target="_top" title="Barrett, The Honors College website">Honors</a>
                              </li>
                              <li>
                                <a href="//cronkite.asu.edu" target="_top" title="Walter Cronkite School of Journalism and Mass Communication website">Journalism</a>
                              </li>
                              <li>
                                <a href="//www.law.asu.edu/" target="_top" title="Sandra Day O' Connor College of Law website">Law</a>
                              </li>
                              <li>
                                <a href="//nursingandhealth.asu.edu/" target="_top" title="College of Nursing and Health Innovation website">Nursing and Health Innovation</a>
                              </li>
                              <li>
                                <a href="//copp.asu.edu" target="_top" title="College of Public Programs website">Public Service and
                        Community Solutions</a>
                              </li>
                              <li>
                                <a href="//schoolofsustainability.asu.edu" target="_top" title="School of Sustainability website">Sustainability</a>
                              </li>
                              <li>
                                <a href="//uc.asu.edu/" target="_top" title="University College website">University College</a>
                              </li>
                              <li>
                                <a target="_top" href="https://thunderbird.asu.edu/" title="Thunderbird School of Global Management website">Thunderbird School of Global Management</a>
                              </li>
                            </ul>
                          </li>
                          <li className="parent">
                            <a href="//www.asu.edu/map/" target="_top">Map and Locations</a>
                            <ul>
                              <li>
                                <a className="border first" href="//www.asu.edu/map/" target="_top">Map</a>
                              </li>
                              <li>
                                <a href="//campus.asu.edu/tempe/" target="_top" title="Tempe campus">Tempe</a>
                              </li>
                              <li>
                                <a href="//campus.asu.edu/west/" target="_top" title="West campus">West</a>
                              </li>
                              <li>
                                <a href="//campus.asu.edu/polytechnic/" target="_top" title="Polytechnic campus">Polytechnic</a>
                              </li>
                              <li>
                                <a href="//campus.asu.edu/downtown/" target="_top" title="Downtown Phoenix campus">Downtown
                        Phoenix</a>
                              </li>
                              <li>
                                <a href="//asuonline.asu.edu/" target="_top" title="Online and Extended campus">Online and
                        Extended</a>
                              </li>
                              <li>
                                <a className="border" href="//havasu.asu.edu/" target="_top">Lake Havasu</a>
                              </li>
                              <li>
                                <a href="https://corporate.asu.edu/" target="_top">Corporate Engagement and Strategic Partnerships</a>
                              </li>
                              <li>
                                <a href="//asuresearchpark.com/" target="_top">Research Park</a>
                              </li>
                              <li>
                                <a href="//washingtoncenter.asu.edu/" target="_top">Washington D.C.</a>
                              </li>
                              <li>
                                <a href="//wpcarey.asu.edu/mba/china-program/english/" target="_top">China</a>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <a href="//isearch.asu.edu/" target="_top" title="Directory, Index and other info">Directory</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div id="asu_search">
                    <div id="asu_search_module" className="asu_search_module" name="asu_search_module">
                      <form target="_top" action="https://search.asu.edu/search" method="get" name="gs" role="search">
                        <label htmlFor="masu_search_box">Search</label>
                        <input name="site" type="hidden" value="default_collection"/>
                        <input name="sort" type="hidden" value="date:D:L:d1"/>
                        <input name="output" type="hidden" value="xml_no_dtd"/>
                        <input name="proxystylesheet" type="hidden" value="asu_frontend"/>
                        <input name="ie" type="hidden" value="UTF-8"/>
                        <input name="oe" type="hidden" value="UTF-8"/>
                        <input name="client" type="hidden" value="asu_frontend"/>
                        <input name="q" className="asu_search_box" id="masu_search_box" placeholder="Search" autoComplete="off" type="text"/>
                        <input className="asu_search_button" type="submit" value="Search"/>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           
  
          </div>
        </div>
      </div>
    </header>
    );
}

export default Header;